<div class="timeline">
  @if ((showLoadingReplacingActivities$ | async) === false) {
    @if (activitySections$ | async; as activitySections) {
      @if (activitySections.length > 0) {
        @for (section of activitySections; track trackActivitySectionsBy($index, section)) {
          <div class="section-container">
            <div class="section-header-container">
              <h2 class="section-header-text">{{ section.name | translate }}</h2>
            </div>
            @if (crmIdentifiers$ | async; as crmIdentifier) {
              @for (activity of section.activities; track trackActivitiesBy($index, activity); let last = $last) {
                @if (enableNewActivityFeed$ | async) {
                  <crm-timeline-activity-v2
                    [activity]="activity"
                    [crmObjectIdentifier]="crmIdentifier"
                    [isLast]="last"
                    [showCopyLink]="showCopyLink()"
                  ></crm-timeline-activity-v2>
                } @else {
                  <crm-timeline-activity
                    [activity]="activity"
                    [crmObjectIdentifier]="crmIdentifier"
                    [isLast]="last"
                    [showCopyLink]="showCopyLink()"
                  ></crm-timeline-activity>
                }
              }
            }
          </div>
        }
      } @else {
        @if ({ filtersPristine: filtersPristine$ | async }; as filtersPristineObj) {
          @if ((loading$ | async) === false) {
            <glxy-empty-state class="empty-state-container">
              <glxy-empty-state-hero>
                <img
                  src="https://storage.googleapis.com/galaxy-libs-public-images/crm/activities-empty-state-v2.svg"
                  [alt]="'CONTACT.ACTIVITIES_TIMELINE.EMPTY.IMAGE_ALT' | translate"
                  />
              </glxy-empty-state-hero>
              @if (filtersPristineObj.filtersPristine) {
                <glxy-empty-state-title>
                  {{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY.HEADER' | translate }}
                </glxy-empty-state-title>
                <p>{{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY.HINT' | translate }}</p>
              } @else {
                <glxy-empty-state-title>
                  {{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY_SEARCH.HEADER' | translate }}
                </glxy-empty-state-title>
                <p>{{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY_SEARCH.HINT' | translate }}</p>
              }
            </glxy-empty-state>
          }
        }
      }
      @if (showLoadingAfterActivities$ | async) {
        <glxy-loading-spinner></glxy-loading-spinner>
      }
    }
  } @else {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
</div>


